export default "__VITE_ASSET__CyPkfSF0__"